import { Injectable } from '@angular/core';
import { UserDto } from '../../../auth/user.dto';
import { Clearances } from '../../../shared/models/enums/clearance.enum';
import { TRsjPermission } from '../permissions';

@Injectable({
  providedIn: 'root',
})
export class RsjPermissionService {
  public getPermissions(user: UserDto): TRsjPermission[] {
    const group: string = user?.groups && user.groups.length > 0 ? user.groups[0] : undefined;
    switch (group) {
      case 'DIRECTION+':
        return user.clearances?.includes(Clearances.CLR_VALIDATOR_RSJ) ? ['RSJ_CAN_ACCESS', 'RSJ_INSTRUCTION_ADVANCED'] : [];
      case 'ADMIN':
        return ['RSJ_CAN_ACCESS', 'RSJ_INSTRUCTION_ADVANCED'];
      case 'STRUCTURE':
        return ['RSJ_CAN_ACCESS'];
      default:
        return [];
    }
  }
}
